module.exports = __webpack_public_path__ + "img/AssociationLineStartIcon9.badd7b08.svg";